import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-body-admin',
  templateUrl: './body-admin.component.html',
  styleUrls: ['./body-admin.component.css']
})
export class BodyAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
